import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const csmExperienceDetailsRoute: InvariantJiraRoute = {
	name: 'csm-experience-details',
	path: '/jira/customer-service-management/experiences/:projectKey/settings/:helpCenterId/details',
	exact: true,
};
